"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"

const toReadableLabel = (value: string): string => {
  const decoded = decodeURIComponent(value)
  const words = decoded.replaceAll("-", " ").replaceAll("_", " ").split(" ")
  return words
    .filter((word) => word.length > 0)
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ")
}

export function RouteBreadcrumb() {
  const pathname = usePathname()

  const segments = pathname.split("/").filter(Boolean)
  const isHomePage = segments.length === 0

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          {isHomePage ? (
            <BreadcrumbPage>Home</BreadcrumbPage>
          ) : (
            <BreadcrumbLink asChild>
              <Link href='/'>Home</Link>
            </BreadcrumbLink>
          )}
        </BreadcrumbItem>

        {segments.map((segment, index) => {
          const href = `/${segments.slice(0, index + 1).join("/")}`
          const isLast = index === segments.length - 1
          const segmentLabel = toReadableLabel(segment)

          return (
            <BreadcrumbItem key={`${href}-${segment}`}>
              <BreadcrumbSeparator />
              {isLast ? (
                <BreadcrumbPage>{segmentLabel}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink>{segmentLabel}</BreadcrumbLink>
              )}
            </BreadcrumbItem>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
